<template>
  <v-col cols="12">
    <template v-if="singleRow">
      <!-- تک ردیف -->
      <v-row>
        <v-col cols="12" sm="2">
          <h3>مانده فعلی :</h3>
        </v-col>
        <v-col cols="12" sm="2">
          <h3 class="balance mt-n2">{{ displayedCurrentBalance }}</h3>
        </v-col>
        <v-col cols="12" sm="2">
          <h3 :class="['mahiat', mahiatClass(currentMahiat)]">{{ currentMahiat }}</h3>
        </v-col>

        <v-col cols="12" sm="2">
          <h3>مانده جدید :</h3>
        </v-col>
        <v-col cols="12" sm="2">
          <h3 class="balance mt-n2">{{ displayedNewBalance }}</h3>
        </v-col>
        <v-col cols="12" sm="2">
          <h3 :class="['mahiat', mahiatClass(newMahiat)]">{{ newMahiat }}</h3>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <!-- دو ردیف -->
      <v-row class="mb-2">
        <v-col cols="12" sm="3">
          <h3>مانده فعلی :</h3>
        </v-col>
        <v-col cols="12" sm="7">
          <h3 class="balance mt-n2">{{ displayedCurrentBalance }}</h3>
        </v-col>
        <v-col cols="12" sm="2">
          <h3 :class="['mahiat', mahiatClass(currentMahiat)]">{{ currentMahiat }}</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="3">
          <h3>مانده جدید :</h3>
        </v-col>
        <v-col cols="12" sm="7">
          <h3 class="balance mt-n2">{{ displayedNewBalance }}</h3>
        </v-col>
        <v-col cols="12" sm="2">
          <h3 :class="['mahiat', mahiatClass(newMahiat)]">{{ newMahiat }}</h3>
        </v-col>
      </v-row>
    </template>
  </v-col>
</template>

<script>
import utils from '../functions/utils'

export default {
  name: 'MyBalances',
  props: {
    balance: {
      type: Object,
      required: true
    },
    singleRow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currentMahiat() {
      return this.getMahiat(this.balance.current)
    },
    newMahiat() {
      return this.getMahiat(this.balance.new)
    },
    displayedCurrentBalance() {
      return this.formatBalance(this.balance.current)
    },
    displayedNewBalance() {
      return this.formatBalance(this.balance.new)
    }
  },
  methods: {
    getMahiat(value) {
      if (value === 0) return 'بی حساب'
      return value > 0 ? 'بدهکار' : 'بستانکار'
    },
    formatBalance(value) {
      // console.log(this.balance.product);
      const isWeight = this.balance.product?.[0]?.unit_type === "2"
      if (isWeight) {
        const main = `${utils.noneAbsDoubleDisplay(value)} ${this.balance.product[0].unit1}`
        // const main = `${utils.noneAbsDoubleDisplay(value)} مثقال`
        const gram = ` (${utils.noneAbsDoubleDisplay(value / this.balance.product[0].n)}${this.balance.product[0].unit2})`
        // const gram = ` (${utils.noneAbsDoubleDisplay(value / 0.217)} گرم)`
        return main + gram
      }
      return Number(value)?.toLocaleString?.() ?? value
    },
    mahiatClass(mahiat) {
      switch (mahiat) {
        case 'بدهکار':
          return 'debt'
        case 'بستانکار':
          return 'credit'
        default:
          return 'neutral'
      }
    },
  }
}
</script>

<style lang="scss">
.balance {
    font-size: 24px;
    color: blue;
}
.mahiat {
    font-weight: bold;
}
.mahiat.debt {
    color: red;
}
.mahiat.credit {
    color: green;
}
.mahiat.neutral {
    color: grey;
}
</style>
